import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import {
  DropdownMenuButton as Button,
  DropdownMenuItem,
  DropdownMenuItems as Items
} from '@jetshop/ui/DropdownMenu';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import { ReactComponent as Carot } from '@jetshop/ui/svg/Carrot.svg';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import React from 'react';
import { FilterDropdownMenu } from './FilterDropdownMenu';
import { theme } from '../../Theme';
import { styled } from 'linaria/react';

export const Box = styled('span')`
  position: relative;
  height: 20px;
  min-width: 20px;
  border: 1px solid #c4c4c4;
  margin-right: 5px;
  &.active {
    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 50%;
      transform: translateY(-50%);
      height: 10px;
      width: 10px;
      border-radius: 100%;
      background: ${theme.colors.accent};
    }
  }
`;

export function ListFilters({ filters }) {
  const listFilters = filters.filter(
    filter => filter.__typename === 'ListFilter'
  );

  if (listFilters.length === 0) return null;

  return listFilters.map(filter => (
    <ErrorBoundary component={PassThrough} key={filter.id}>
      <ListFilter filter={filter} />
    </ErrorBoundary>
  ));
}

function ListFilter({ filter }) {
  const { apply, clear } = useListFilter({ filter });
  const onSelect = value => () => apply({ value });

  return (
    <FilterDropdownMenu>
      <Button>
        <span>{filter.name}</span>
        {filter.hasActiveItems ? <Check /> : <Carot className="carot" />}
      </Button>
      <Items as="ul">
        {filter.items.map((item, index) => (
          <React.Fragment key={index}>
            {item.resultCount > 0 && (
              <DropdownMenuItem
                key={item.id}
                onSelect={item.resultCount > 0 && onSelect(item.value)}
                style={
                  item.resultCount === 0
                    ? {
                        opacity: 0.4,
                        cursor: 'not-allowed'
                      }
                    : { cursor: 'pointer' }
                }
              >
                <Box className={item.isActive ? 'active' : 'not-active'} />
                <span>{item.text}</span>
              </DropdownMenuItem>
            )}
          </React.Fragment>
        ))}
        <>
          {filter.hasActiveItems && (
            <DropdownMenuItem
              onSelect={({ setIsOpen }) => {
                setIsOpen(false);
                clear();
              }}
            >
              {t('Clear filter')}
            </DropdownMenuItem>
          )}
        </>
      </Items>
    </FilterDropdownMenu>
  );
}
